// components/DomainDetails.tsx
"use client";
import React from "react";
import { Spinner } from "react-bootstrap";
import useFetchDomainDetails from "./useFetchDomainDetails";
import DomainDynamic from "./DomainDynamic";

interface DomainDetailsProps {
  domainName: string;
}

const DomainDetails: React.FC<DomainDetailsProps> = ({ domainName }) => {
  const { domainDetails, loading, error } = useFetchDomainDetails(domainName);

  if (loading) {
    return <Spinner animation="border" aria-label="Loading domain details..." />;
  }

  if (error) {
    return <div>Error loading domain details: {error.message}</div>;
  }

  if (!domainDetails) {
    return <div>No domain details found</div>;
  }
  console.log("DOMAIN DETAILS RECEIVED:", domainDetails);

  return <DomainDynamic domain={domainDetails} />;
};

export default DomainDetails;
